import styled from 'styled-components';
import { Link } from 'react-router-dom';

export var MusicContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  align-items: center;
  max-width: 410px;
  margin: 0 auto;
  padding-top: 0.75rem;
`;

export var HeroPlayButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid white;
  background: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export var SectionHeading = styled.div`
  font-weight: 900;
  font-size: 0.9rem;
  width: 100%;
  margin-bottom: 0.5rem;
`;

export var BackChevron = styled(Link)`
  color: #999;
  text-decoration: none;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  align-self: flex-start;

  &:hover {
    color: #333;
  }
`;

export var MusicCard = styled.div`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 8px;
  background: white;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
`;

export var TabBar = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 0;
`;

export var Tab = styled.button`
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-family: inherit;
  color: ${function (p) {
    return p.$active ? '#000' : '#999';
  }};
  font-weight: ${function (p) {
    return p.$active ? '700' : '400';
  }};
  border-bottom: ${function (p) {
    return p.$active ? '2px solid #000' : '2px solid transparent';
  }};
`;

export var CommunitySection = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export var EmptyText = styled.p`
  text-align: center;
  color: #999;
  font-size: 0.9rem;
  margin-top: 2rem;
`;
